import { styled } from "@mui/material";

import { Button } from "@citrine/atoms/button";

export const DeleteButton = styled(Button)(({ theme }) => ({
  borderColor: theme.palette.error.main,

  ":hover": {
    backgroundColor: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
}));
